namespace Areas.Dialogs.BudgetAccountCategory {
    "use strict";

    let accountId: number;
    let budgetId: number

    export function getAccountId() {
        return accountId;
    }

    export function getBudgetId() {
        return budgetId;
    }


    export function addGridButtons(e: any) {
        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { class: "dxButton lightblue" },
            text: "Clear Filter",
            hint: "Show All Categories",
            type: "default",
            onClick: clearGridFilter
        }, "before");
    }

    function clearGridFilter() {
        const dataGrid = $("#BudgetAccountCategoryLinkGrid").dxDataGrid("instance");
        dataGrid.clearFilter();
    }

    export class BudgetAccountCategoryLinkDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void,
            parameters: any = null,
            rootElementId: string = "dialog") {
            super("BudgetAccountCategoryLink",
                closeHandler,
                parameters, () => {
                    accountId = parameters.accountId;
                    budgetId = parameters.budgetId;
                    Areas.refreshGrid("BudgetAccountCategoryLinkGrid");
                    const dataGrid = $(`#${this.dialogName}Grid`).dxDataGrid('instance');
                    dataGrid.filter(["ucopSubCodeLk", "=", parameters.sub]);
                },
                rootElementId);

        }

        protected ok = (e: any) => {

            const dataGrid = $(`#${this.dialogName}Grid`).dxDataGrid('instance');
            const selectedRows: any = dataGrid.getSelectedRowsData();

            if (selectedRows[0] == null) {
                DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
            } else {
                var data = selectedRows[0];
                this.close(DialogResult.Ok, data);
            }
        }
    }

}
